import { Injectable } from '@angular/core';

import { CusHttp } from '../../core/services/CusHttp';
//企业信息详情
const COMPANYHURL = "v1/company/";
//推荐岗位
const RECOMMENDJOBURL = 'v1/position/hot-rec?type=rec&num=5';
// 企业详情中的动态数据展示
const DYNAMICDATAURL = 'v1/company/dynamicdata?id=';
//根据企业id获取岗位信息列表 api.shixi.com:81/
const COMPANYJOBLISTURL = 'v1/position/list';
// 学生收藏获取取消收藏企业接口  v1/company-collect/collect
const POSTSTUFAVORCOMPANY = 'v1/company-collect/collect';

//检查企业是否被收藏接口
const CHECKCOMPANYFACOR = 'v1/company-collect/check';

//学生收藏获取取消收藏企业接口
const POSTSTUCOMPANYFACOR = 'v1/company-collect/collect';

// 增加企业浏览量
const POSTCOMPANYBROWESES = 'v1/company/browses';

@Injectable()
export class CompanyService {

  constructor(
    public _http: CusHttp,
  ) { }
  getCompanyDatailData(id: string) { //企业信息详情
    let url = COMPANYHURL + `${id}?fields=&expand=industry,province,area,cityss,scale,nature`;
    return this._http.get(url);
  }
  //推荐企业
  getRecommendData() {
    return this._http.get(RECOMMENDJOBURL);
  }
  // 企业详情中的动态数据展示
  getDynamic(id: string) {
    let url = DYNAMICDATAURL + `${id}`;
    return this._http.get(url);
  }
  //根据企业id获取岗位信息列表 api.shixi.com:81/
  getCompanyJob(id: string, page?: number) {
    !page ? page = 1 : page;
    let url = COMPANYJOBLISTURL + `?company_id=${id}`;
    return this._http.get(url);
  }
  //检查企业是否被收藏接口
  checkStuFacorCompany(stuid: string, comId: string) { //企业信息详情
    let url = CHECKCOMPANYFACOR + `?company_id=${comId}&student_id=${stuid}`;
    return this._http.get(url);
  }

  //学生收藏获取取消收藏企业接口
  postStuFacorCompany(obj: Object) {
    // let params = new URLSearchParams();
    // for (let option in obj) { params.append(option, obj[option]) }
    let url = POSTSTUCOMPANYFACOR;
    return this._http.post(url, obj);
  }

  // 增加企业浏览量
  // const POSTCOMPANYBROWESES = 'v1/company/browses';
  postCompanyBrowsesData(did: any) {
    let params = new URLSearchParams();
    params.append('id', did);
    let url = POSTCOMPANYBROWESES;
    return this._http.post(url, params.toString());
  }



}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/job/company/company.service.ts